// 画面の切り替えの動き。React の <ViewTransition>（View Transitions API）を使い、動きの形は motion.css に置く。
// 対応しないブラウザや「動き: 減らす」では、これまでどおりすぐに切り替わる。
import { addTransitionType, startTransition, ViewTransition, type ReactNode } from 'react';

export type StepDirection = 'step-forward' | 'step-back';

/** 「動き: 減らす」を選んだか、設定がなく端末で動きを減らしているとき */
export function motionReduced(): boolean {
  const motion = document.documentElement.dataset.motion;
  if (motion) return motion === 'reduced';
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
}

/** 段階を進める・戻す更新。動きを減らしていなければ、向きつきの View Transition として描き直す */
export function moveStep(direction: StepDirection, update: () => void): void {
  if (motionReduced()) {
    update();
    return;
  }
  startTransition(() => {
    addTransitionType(direction);
    update();
  });
}

/** ページの中身。入れ替わるときに古い方が上へ消え、新しい方が下から出る（ページの移動は react-router が transition で行う） */
export function PageTransition({ children }: { children: ReactNode }) {
  return (
    <ViewTransition enter="page-enter" exit="page-exit" default="none">
      {children}
    </ViewTransition>
  );
}

/** 作成の段階など、向きのある入れ替え。進むときは右から、戻るときは左から出る */
export function StepTransition({ children }: { children: ReactNode }) {
  return (
    <ViewTransition
      enter={{ 'step-forward': 'step-in-forward', 'step-back': 'step-in-back', default: 'page-enter' }}
      exit={{ 'step-forward': 'step-out-forward', 'step-back': 'step-out-back', default: 'page-exit' }}
      default="none"
    >
      {children}
    </ViewTransition>
  );
}
